import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getPreferredLang, isCardLang } from "@/locale/appLang";
import { localizedPath, parseLocalePath } from "@/locale/routes";

/** Первый визит на `/`: только uk/ky по языку браузера. kk/uz не редиректим — визитка вручную. */
export function LocaleAutoRedirect() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  const synced = useRef(false);

  useEffect(() => {
    if (synced.current) return;
    synced.current = true;

    const { basePath, lang: urlLang } = parseLocalePath(pathname);
    // Не уводим с явных префиксов; legacy /ru обрабатывает LegacyRuRedirect.
    if (urlLang !== "ru") return;
    const preferred = getPreferredLang(pathname);
    if (preferred === "ru" || isCardLang(preferred)) return;
    navigate(`${localizedPath(basePath, preferred)}${search}${hash}`, { replace: true });
  }, [pathname, search, hash, navigate]);

  return null;
}
